import React from 'react';
export const Protection = () => (
  <svg width="201px" height="157px" viewBox="0 0 201 157" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1028.000000, -743.000000)">
        <path
          d="M1176.56983,897 L1080.43037,897 L1028.50857,844.961239 C1027.83048,844.281624 1027.83048,843.169606 1028.50857,842.489991 L1127.26703,743.509056 C1127.946,742.830315 1129.05466,742.830315 1129.73275,743.509056 L1228.49208,842.489991 C1229.16931,843.169606 1229.16931,844.281624 1228.49208,844.961239 L1176.56983,897 Z"
          fill="#F3F4F6"
          fillRule="nonzero"
        />
        <path
          d="M1204,896 L1172,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1085,896 L1066,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1056,896 L1048,896"
          stroke="#EB1D26"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1147,895.999522 C1147,898.208727 1139.38941,900 1130,900 C1120.61158,900 1113,898.208727 1113,895.999522 C1113,893.790317 1120.61158,892 1130,892 C1139.38941,892 1147,893.790317 1147,895.999522"
          fill="#D0D7DA"
        />
        <g transform="translate(1079.000000, 820.000000)">
          <path
            d="M5.5001,5.8939 L6.4011,1.7809 C6.6601,0.5989 7.8271,-0.1491 9.0081,0.1099 L54.1371,9.9929 C55.3191,10.2509 56.0671,11.4179 55.8081,12.5999 L50.1831,38.2889 C49.9241,39.4699 48.7561,40.2169 47.5751,39.9589 L2.4461,30.0769 C1.2651,29.8179 0.5171,28.6509 0.7751,27.4689 L4.5411,10.2729"
            fill="#FFFFFF"
          />
          <path
            d="M5.5001,5.8939 L6.4011,1.7809 C6.6601,0.5989 7.8271,-0.1491 9.0081,0.1099 L54.1371,9.9929 C55.3191,10.2509 56.0671,11.4179 55.8081,12.5999 L50.1831,38.2889 C49.9241,39.4699 48.7561,40.2169 47.5751,39.9589 L2.4461,30.0769 C1.2651,29.8179 0.5171,28.6509 0.7751,27.4689 L4.5411,10.2729"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M1127.64006,838.97437 L1108.86422,835.022438 C1108.26837,834.896313 1107.89178,834.344163 1108.0278,833.795751 C1108.16382,833.246404 1108.76373,832.899793 1109.36059,833.025918 L1128.13542,836.97785 C1128.73228,837.103976 1129.10888,837.656125 1128.97184,838.204537 C1128.83582,838.753884 1128.23591,839.099561 1127.64006,838.97437"
          fill="#DDE5E8"
        />
        <path
          d="M1126.64006,842.974082 L1107.86422,839.02215 C1107.26837,838.896024 1106.89178,838.344809 1107.0278,837.795463 C1107.16382,837.246116 1107.76373,836.900439 1108.36059,837.02563 L1127.13542,840.977562 C1127.73228,841.103687 1128.10888,841.655837 1127.97184,842.204249 C1127.83582,842.753596 1127.23591,843.100207 1126.64006,842.974082"
          fill="#DDE5E8"
        />
        <path
          d="M1099.15365,845.962212 L1088.25286,843.531585 C1087.39272,843.340008 1086.84822,842.478912 1087.03761,841.608835 L1089.94455,828.267325 C1090.13394,827.397248 1090.98521,826.846466 1091.84635,827.038042 L1102.74714,829.46867 C1103.60728,829.660246 1104.15178,830.520345 1103.96239,831.39142 L1101.05545,844.732929 C1100.86606,845.604004 1100.01479,846.152791 1099.15365,845.962212"
          fill="#FFFFFF"
        />
        <path
          d="M1099.15365,845.962212 L1088.25286,843.531585 C1087.39272,843.340008 1086.84822,842.478912 1087.03761,841.608835 L1089.94455,828.267325 C1090.13394,827.397248 1090.98521,826.846466 1091.84635,827.038042 L1102.74714,829.46867 C1103.60728,829.660246 1104.15178,830.520345 1103.96239,831.39142 L1101.05545,844.732929 C1100.86606,845.604004 1100.01479,846.152791 1099.15365,845.962212 Z"
          stroke="#DDE5E8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1097.72748,834.509223 C1097.72748,834.509223 1097.96763,835.268648 1097.41736,836.74092 C1097.41736,836.74092 1097.00805,838.087634 1095.79057,838.615181 L1098,840.270728 L1097.88201,840.339582 C1096.78983,840.951172 1095.46271,841.170899 1094.1429,840.859029 C1092.82309,840.546146 1091.75075,839.757356 1091.071,838.726563 L1091,838.613156 L1091.61918,838.503799 L1093.74717,838.131174 C1092.91811,837.118607 1093.21256,835.745567 1093.21256,835.745567 C1093.42348,834.19229 1093.9821,833.621202 1093.9821,833.621202 C1093.9821,833.621202 1094.74329,832.749382 1096.10486,833.071378 C1097.46644,833.394387 1097.72748,834.509223 1097.72748,834.509223"
          fill="#DDE5E8"
        />
        <path
          d="M1104,847.578821 C1104.95684,847.613777 1105.83821,847.092529 1106.65922,846.589788 C1108.0658,845.726182 1109.47138,844.862577 1110.87796,844 C1110.16662,845.194654 1109.45528,846.38828 1108.74293,847.582934 C1109.41403,847.831734 1110.14851,847.493489 1110.76225,847.123372 C1111.377,846.751199 1112.02797,846.322481 1112.7383,846.386223 C1113.44964,846.448938 1114.09558,847.323852 1113.66999,847.908842 C1113.87021,848.78684 1113.28866,849.771761 1112.43646,850 C1112.62662,848.94928 1113.45065,848.100069 1114.40749,847.667238 C1115.36332,847.233379 1116.43988,847.16244 1117.48526,847.202536 C1118.13019,847.22721 1118.83449,847.321796 1119.27719,847.800891 C1119.7209,848.281014 1119.63739,849.256683 1119.01056,849.416038 C1120.57611,848.733379 1122.38314,848.653187 1124,849.193968"
          stroke="#DDE5E8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1108,792 L1108,794" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1108,797 L1108,799" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1112,795 L1110,795" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1107,795 L1105,795" stroke="#AA81F7" strokeLinecap="round" />
        <path d="M1170,868 L1170,870" stroke="#D62793" strokeLinecap="round" />
        <path d="M1170,874 L1170,876" stroke="#D62793" strokeLinecap="round" />
        <path d="M1174,872 L1172,872" stroke="#D62793" strokeLinecap="round" />
        <path d="M1168,872 L1166,872" stroke="#D62793" strokeLinecap="round" />
        <path
          d="M1181,864.5 C1181,865.329051 1180.32905,866 1179.5,866 C1178.67194,866 1178,865.329051 1178,864.5 C1178,863.671937 1178.67194,863 1179.5,863 C1180.32905,863 1181,863.671937 1181,864.5"
          fill="#CCD82B"
        />
        <path
          d="M1085,810.500494 C1085,811.328284 1084.32806,812 1083.5,812 C1082.67194,812 1082,811.328284 1082,810.500494 C1082,809.671716 1082.67194,809 1083.5,809 C1084.32806,809 1085,809.671716 1085,810.500494"
          fill="#F5C400"
        />
        <path
          d="M1150,838.984241 C1150,860.542817 1131.00051,866 1131.00051,866 C1131.00051,866 1112,860.921037 1112,838.984241 L1112,823.002918 L1119.97819,823.002918 C1127.11551,823.002918 1130.93077,818 1130.93077,818 C1130.93077,818 1134.59847,823.002918 1142.29873,823.002918 L1150,823.002918 L1150,838.984241 Z"
          fill="#FFFFFF"
        />
        <path
          d="M1150,838.984241 C1150,860.542817 1131.00051,866 1131.00051,866 C1131.00051,866 1112,860.921037 1112,838.984241 L1112,823.002918 L1119.97819,823.002918 C1127.11551,823.002918 1130.93077,818 1130.93077,818 C1130.93077,818 1134.59847,823.002918 1142.29873,823.002918 L1150,823.002918 L1150,838.984241 Z"
          stroke="#7350A0"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1147,839.752011 C1147,858.303926 1131,863 1131,863 C1131,863 1142.97019,860.847262 1140.51497,826 L1147,826 L1147,839.752011 Z"
          fill="#F2F3F3"
        />
        <g transform="translate(1123.000000, 834.000000)">
          <path
            d="M4.2916,1.1605 C5.3476,0.5855 6.5596,0.2575 7.8496,0.2575 C11.9426,0.2575 15.2616,3.5585 15.2616,7.6305 C15.2616,11.7025 11.9426,15.0035 7.8496,15.0035 C3.7556,15.0035 0.4376,11.7025 0.4376,7.6305 C0.4376,6.6125 0.6446,5.6425 1.0196,4.7605"
            fill="#FFFFFF"
          />
          <path
            d="M4.2916,1.1605 C5.3476,0.5855 6.5596,0.2575 7.8496,0.2575 C11.9426,0.2575 15.2616,3.5585 15.2616,7.6305 C15.2616,11.7025 11.9426,15.0035 7.8496,15.0035 C3.7556,15.0035 0.4376,11.7025 0.4376,7.6305 C0.4376,6.6125 0.6446,5.6425 1.0196,4.7605"
            stroke="#CCD82B"
            strokeLinecap="round"
          />
        </g>
        <polyline
          stroke="#575700"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="1134 840 1132.03115 841.992474 1130.11596 844 1128.1212 842.125118 1128 842.011289"
        />
      </g>
    </g>
  </svg>
);
